/* eslint-disabled */

export default class NotificationExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
